export enum OrderCargoOrderDetailsHandlingLogType {
  FORWARD = "FORWARD",
  FORWARD_CANCEL = "FORWARD_CANCEL",
  ACCEPTED_CPE_CANDIDATURE = "ACCEPTED_CPE_CANDIDATURE",
  ACCEPTED_CSO_CANDIDATURE = "ACCEPTED_CSO_CANDIDATURE",
  ACCEPTED_DSO_CANDIDATURE = "ACCEPTED_DSO_CANDIDATURE",
}

export type OrderCargoOrderDetailsHandlingLogAuthor = {
  firstName: string;
  lastName: string;
};

export type OrderCargoOrderDetailsHandlingLogAssignmentOrderNewPlanItem = {
  type: OrderCargoOrderDetailsHandlingLogType.ACCEPTED_CPE_CANDIDATURE;
  driverName: string;
  taxiCorporationName: string;
  createDate: Date;
  author: OrderCargoOrderDetailsHandlingLogAuthor;
};

export type OrderCargoOrderDetailsHandlingLogAssignmentOrderExistingPlanItem = {
  type: OrderCargoOrderDetailsHandlingLogType.ACCEPTED_CSO_CANDIDATURE;
  driverName: string;
  taxiCorporationName: string;
  createDate: Date;
  author: OrderCargoOrderDetailsHandlingLogAuthor;
  planEntryUuid: number;
};

export type OrderCargoOrderDetailsHandlingLogAssignmentOrderCancelContentItem =
  {
    type: OrderCargoOrderDetailsHandlingLogType.ACCEPTED_DSO_CANDIDATURE;
    createDate: Date;
    author: OrderCargoOrderDetailsHandlingLogAuthor;
    planEntryUuid: number;
  };

export type OrderCargoOrderDetailsHandlingLogItem = {
  type: OrderCargoOrderDetailsHandlingLogType.FORWARD;
  author: OrderCargoOrderDetailsHandlingLogAuthor;
  contractDisplayName: string;
  createDate: Date;
};

export type OrderCargoOrderDetailsHandlingLogCancelItem = {
  type: OrderCargoOrderDetailsHandlingLogType.FORWARD_CANCEL;
  author: OrderCargoOrderDetailsHandlingLogAuthor;
  producerDisplayName: string;
  consumerDisplayName: string;
  createDate: Date;
};

export type OrderCargoOrderDetailsHandlingLogData =
  | OrderCargoOrderDetailsHandlingLogItem
  | OrderCargoOrderDetailsHandlingLogCancelItem
  | OrderCargoOrderDetailsHandlingLogAssignmentOrderNewPlanItem
  | OrderCargoOrderDetailsHandlingLogAssignmentOrderExistingPlanItem
  | OrderCargoOrderDetailsHandlingLogAssignmentOrderCancelContentItem;

type OrderCargoOrderDetailsHandlingLog = {
  data: OrderCargoOrderDetailsHandlingLogData[];
};

export default OrderCargoOrderDetailsHandlingLog;
